import { EbUser } from "../classes/user";
import { UserRole, StatusDemande, ServiceType, AccessRights } from "../utils/enumeration";
import { AuthenticationService } from "../services/authentication.service";
import { EbEtablissement } from "../classes/etablissement";

export class ConnectedUserComponent
{
	public UserRole=UserRole;
	public isChargeur: boolean = false;
	public isAdmin: boolean = false;
	public isPrestataire: boolean = false;
	public isTransporteur: boolean = false;
	public isBroker: boolean = false;
	public isTransporteurBroker: boolean = false;
	public isControlTower: boolean = false;
	public isCtConnectedAs: boolean = false;
	public userConnected: EbUser = AuthenticationService.getConnectedUser();
	public isAuthenticated: boolean = false;
	public isSuperAdmin: boolean = false;
	public ebUserNum: number;

	constructor(
		protected authenticationService? : AuthenticationService,
	) {
		// this.authenticationService.connectedUser.subscribe(tocken => {
			//TODO : reste a optimiser cette partie . Il faudrait trouver un autre moyen d'envoyer directement l'utilisateur  connecté et non le tocken
			this.checkChange();
		// });
	}

	checkChange() {
		this.userConnected =  AuthenticationService.getConnectedUser();
		this.initUser();
	}

	initUser() {
		if (this.userConnected !== null) {
			this.ebUserNum = this.userConnected.ebUserNum;
			if (this.userConnected.admin) this.isAdmin = true;
			if (this.userConnected.superAdmin) this.isSuperAdmin = true;
			if(this.userConnected.realUserNum && this.userConnected.realUserEtabNum){
				this.isCtConnectedAs = true;
			}
			if (this.userConnected.role == UserRole.CHARGEUR) this.isChargeur = true;
			else if (this.userConnected.role == UserRole.CONTROL_TOWER) this.isControlTower = true;
			else if (this.userConnected.role == UserRole.PRESTATAIRE) {
				this.isPrestataire = true;
				if (this.userConnected.service == ServiceType.BROKER) this.isBroker = true;
				else if (this.userConnected.service == ServiceType.TRANSPORTEUR) this.isTransporteur = true;
				else if (this.userConnected.service == ServiceType.TRANSPORTEUR_BROKER) this.isTransporteurBroker = true;
			}
			this.isAuthenticated = (this.userConnected.status == StatusDemande.ACCPETER);
		}
		else {
			this.isAdmin = false;
			this.isControlTower = false;
			this.isChargeur = false;
			this.isPrestataire = false;
			this.isBroker = false;
			this.isTransporteur = false;
			this.isTransporteurBroker = false;
			this.isSuperAdmin = false;
			this.isCtConnectedAs = false;
		}
	}

	hasAccess(ecModule){
		if(!this.userConnected || !this.userConnected.listAccessRights)
			return false;

		if(this.userConnected.listAccessRights && this.userConnected.listAccessRights.length == 0)
			return false;

		return this.userConnected.listAccessRights.find(access => {
			if(access.module.ecModuleNum == ecModule && access.accessRight == AccessRights.NON_VISIBLE)
				return true;
		}) ? false : true;
	}

	getAccessRight(ecModule){
		if(!this.userConnected || !this.userConnected.listAccessRights)
			return AccessRights.NON_VISIBLE;

		if(this.userConnected.listAccessRights && this.userConnected.listAccessRights.length == 0)
			return AccessRights.NON_VISIBLE;

		let access = this.userConnected.listAccessRights.find(access => {
			if(access.module.ecModuleNum == ecModule)
				return true;
		});

		if(access) return access.accessRight;
		return AccessRights.NON_VISIBLE;
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/connectedUserComponent.ts